import axios from 'axios';

/**
 * Download a file from a URL as a blob
 */
export const downloadFileAsBlob = async (
  url: string,
  filename: string
): Promise<void> => {
  try {
    // Fetch the file as blob
    const response = await axios.get(url, {
      responseType: 'blob',
      withCredentials: false,
      headers: {
        'Accept': 'image/*'
      }
    });
    
    // Create blob URL
    const blob = new Blob([response.data], { 
      type: response.headers['content-type'] || 'application/octet-stream' 
    });
    const blobUrl = window.URL.createObjectURL(blob);
    
    // Create download link
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    
    // Add to DOM and trigger download
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
  } catch (error) {
    console.error('Download failed, opening in new tab:', error);
    // Fallback: open in new tab
    window.open(url, '_blank');
  }
};

/**
 * Generate a safe filename from a title
 */
export const generateSafeFilename = (
  title: string,
  extension: string = 'jpeg'
): string => {
  const safeName = title
    .replace(/[^a-z0-9]/gi, '_')
    .toLowerCase();
  return `${safeName}.${extension}`;
};
